<app-layout-dialogheader1 [title]="'Change user password'" [titlesub]="" mat-dialog-title>

  </app-layout-dialogheader1>

<mat-dialog-content>

  <div class="form-group" [formGroup]="myform">
      <mat-form-field class="">
          <input matInput type="text" formControlName="userpassword" required placeholder="New password" minlength="8" maxlength="32">
          <mat-hint align="end">Minimum length is 8.</mat-hint>
          <mat-error *ngIf="myform.get('userpassword').hasError('required')">
              Password is <strong>required</strong>
          </mat-error>
          <mat-error *ngIf="myform.get('userpassword').hasError('minlength')">
              Password should contain 8 characters
          </mat-error>
      </mat-form-field>
      <div class="clearfix"></div>
      <!--       </form> -->
    </div>


  <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
  </mat-dialog-content>
  <div mat-dialog-actions style="width:100%;" class="justify-content-end">     
    <mat-progress-bar mode="indeterminate" *ngIf="submitted"></mat-progress-bar>
    <button mat-raised-button type="button" (click)="changepch()" [disabled]="!myform.valid||submitted" class="btn btn-success ">Change</button>
    <button mat-raised-button mat-dialog-close class="btn ">Close</button>
  </div>
